export function formatPrice( price, fullDecimals = false ) {
    return price.toLocaleString('pt-br', {
        minimumFractionDigits: 2,
        maximumFractionDigits: fullDecimals ? 6 : 2
    });
}

export function priceToFloat( price ){
    if( !isNaN(price) ){
        return price;
    }

    if( price === '' ){
        price = '0';
    }

    price = price.replace(/\./g, "").replace(",", ".");

    return parseFloat(price);
}
